import React, {useEffect, useState} from 'react';
import AppsContainer from '../../../../@crema/core/AppsContainer';
import AppRowContainer from '../../../../@crema/core/AppRowContainer';
import {Button, Col, Form, Input, Modal, Popconfirm, Select, Space} from 'antd';
import AppScrollbar from '../../../../@crema/core/AppScrollbar';
import './index.style.less';
import AppPageMetadata from '../../../../@crema/core/AppPageMetadata';
import {useMatch, useNavigate} from 'react-router-dom';
import {AppLoader} from '../../../../@crema';
import {useOpenNotification} from '../../../../utility/hooks/NotificationHooks';
import {useQuote, useQuoteActions} from '../../../../utility/hooks/QuoteHooks';
import AppTableContainer from '../../../../@crema/core/AppTableContainer';
import {DeleteOutlined} from '@ant-design/icons';
import {SHOW_ACTIVE_CONDITIONS} from '../../../../services/conditions/ConditionsProvider';
import {useAuthUser} from '../../../../@crema/utility/AuthHooks';
import NeedUserEmailVerification from '../../../auth/NeedUserEmailVerification';

export const quoteColumns = [
  {
    name: 'CUSTOM1',
    value: 'CUSTOM1',
  },
  {
    name: 'CUSTOM2',
    value: 'CUSTOM2',
  },
  {
    name: 'CUSTOM3',
    value: 'CUSTOM3',
  },
  {
    name: 'CUSTOM4',
    value: 'CUSTOM4',
  },
  {
    name: 'CUSTOM5',
    value: 'CUSTOM5',
  },
  {
    name: 'CUSTOM6',
    value: 'CUSTOM6',
  },
  {
    name: 'CUSTOM7',
    value: 'CUSTOM7',
  },
  {
    name: 'CUSTOM8',
    value: 'CUSTOM8',
  },
  {
    name: 'CUSTOM9',
    value: 'CUSTOM9',
  },
  {
    name: 'CUSTOM10',
    value: 'CUSTOM10',
  },
  {
    name: 'CUSTOM11',
    value: 'CUSTOM11',
  },
  {
    name: 'CUSTOM12',
    value: 'CUSTOM12',
  },
  {
    name: 'CUSTOM13',
    value: 'CUSTOM13',
  },
  {
    name: 'CUSTOM14',
    value: 'CUSTOM14',
  },
  {
    name: 'CUSTOM15',
    value: 'CUSTOM15',
  },
  {
    name: 'CUSTOM16',
    value: 'CUSTOM16',
  },
  {
    name: 'CUSTOM17',
    value: 'CUSTOM17',
  },
  {
    name: 'CUSTOM18',
    value: 'CUSTOM18',
  },
  {
    name: 'CUSTOM19',
    value: 'CUSTOM19',
  },
];

const QuotePage = () => {
  const match = useMatch('quotes/:quoteId');
  const quoteId = match ? match.params.quoteId : undefined;
  const [isOpen, setOpen] = useState(false);
  const {openSuccessNotification, openErrorNotification} =
    useOpenNotification();

  const {loading, quote} = useQuote();
  const {fetchQuote, patch, deleteQuoteField, createQuoteField} =
    useQuoteActions();
  const [form] = Form.useForm();
  const [formQuoteFields] = Form.useForm();
  const navigate = useNavigate();
  const user = useAuthUser();
  const isVerified = !!user?.user?.isVerified;

  const columns = [
    {
      title: 'Key',
      dataIndex: 'key',
      width: '90%',
    },
    {
      title: 'Actions',
      key: 'action',
      render: (text, record) => {
        return (
          <Space size='middle'>
            <Popconfirm
              title='Are you sure?'
              onConfirm={() => removeQuoteField(record.id)}>
              <a title={'Remove'}>
                <DeleteOutlined />
              </a>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];

  const quoteFields = quote && quote.type === 4 ? quote.fields : [];

  const initialValues = {
    column: quote ? quote.column : undefined,
    label: quote ? quote.label : undefined,
  };

  useEffect(() => {
    if (quoteId) {
      fetchQuote(quoteId);
    }
  }, []);

  const removeQuoteField = (id) => {
    deleteQuoteField(id)
      .then(({data}) => {
        fetchQuote(quote?.id);
        openSuccessNotification('Quote field successfully deleted!');
        if (data.data?.isConditionsHasChangedQuotes) {
          window.localStorage.setItem(SHOW_ACTIVE_CONDITIONS, '0');
          navigate('/conditions');
        }
      })
      .catch((e) => {
        console.log(e);
        openErrorNotification('Error during quote field deleting!');
      });
  };

  const onFinish = (values) => {
    patch(quote?.id, values['column'], values['label'])
      .then(({data}) => {
        if (data.data?.isConditionsHasChangedQuotes) {
          window.localStorage.setItem(SHOW_ACTIVE_CONDITIONS, '0');
          navigate('/conditions');
        }
        openSuccessNotification('Quote successfully updated!');
      })
      .catch((e) => {
        console.log(e);
        openErrorNotification('Error during quote update!');
      });
  };

  const onFinishQuoteField = (values) => {
    createQuoteField(values['key'])
      .then(() => {
        fetchQuote(quote?.id);
        openSuccessNotification('Quote field successfully added!');
        setOpen(false);
      })
      .catch((e) => {
        console.log(e);
        openErrorNotification('Error during quote field adding!');
      });
  };

  const onOpen = () => {
    setOpen(true);
  };

  return (
    <>
      {isVerified ? (
        <AppsContainer
          cardStyle={{
            backgroundColor: 'white',
            boxShadow: 'none',
            padding: '15px',
            height: 'auto',
            marginBottom: '40px',
          }}
          fullView>
          <AppPageMetadata title='Quote' />
          <AppRowContainer>
            {!loading ? (
              <>
                <Col xs={24} md={24} xl={24} xxl={24}>
                  <h2>{quote ? `Quote "${quote.label}"` : 'Quote'}</h2>
                </Col>
                <Col
                  xs={24}
                  md={24}
                  xl={24}
                  xxl={24}
                  className='wall-left-sidebar'>
                  <AppScrollbar className='wall-scrollbar'>
                    <Form
                      form={form}
                      onFinish={onFinish}
                      initialValues={initialValues}
                      onFieldsChange={null}
                      layout={'vertical'}>
                      <div className='quote-edit__form'>
                        <AppRowContainer gutter={16}>
                          <Col xs={24} md={24}>
                            <Form.Item shouldUpdate className='save-btn'>
                              <Button type='primary' htmlType='submit'>
                                Save
                              </Button>
                            </Form.Item>
                          </Col>
                          <Col xs={24} md={24}>
                            <Form.Item
                              name={'label'}
                              className='form-field'
                              label={'WatchList Column Name'}
                              rules={[
                                {
                                  required: true,
                                  message: 'This field is required',
                                },
                              ]}>
                              <Input type={'text'} placeholder={'Label'} />
                            </Form.Item>
                          </Col>
                          <Col xs={24} md={24}>
                            <Form.Item
                              name={'column'}
                              className='form-field'
                              label={'Watchlist Column'}
                              placeholder={'Watchlist Column'}
                              rules={[
                                {
                                  required: true,
                                  message: 'This field is required',
                                },
                              ]}>
                              <Select>
                                {quoteColumns.map((quoteColumn) => (
                                  <Select.Option
                                    key={quoteColumn.name}
                                    value={quoteColumn.value}>
                                    {quoteColumn.name}
                                  </Select.Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                        </AppRowContainer>
                      </div>
                    </Form>
                  </AppScrollbar>
                </Col>
                <Col xs={24} md={24} xl={24} xxl={24}>
                  {quote && quote.type === 4 && (
                    <>
                      <h2>Quote Fields</h2>
                      <Button type={'primary'} onClick={() => onOpen()}>
                        Add
                      </Button>
                      <Modal
                        title={'Add'}
                        open={isOpen}
                        footer={null}
                        onCancel={() => setOpen(false)}
                        className='add-modal'>
                        <Form
                          form={formQuoteFields}
                          onFinish={onFinishQuoteField}
                          initialValues={{}}
                          layout={'horizontal'}>
                          <div className='billing-address__add-form'>
                            <AppRowContainer gutter={16}>
                              <Col xs={20} md={20}>
                                <Form.Item
                                  name={'key'}
                                  className='form-field'
                                  label={'Key'}
                                  rules={[
                                    {
                                      required: true,
                                      message: 'This field is required',
                                    },
                                  ]}>
                                  <Input type={'text'} placeholder={'Key'} />
                                </Form.Item>
                              </Col>
                              <Col xs={4} md={4}>
                                <Form.Item shouldUpdate className='save-btn'>
                                  <Button type='primary' htmlType='submit'>
                                    Save
                                  </Button>
                                </Form.Item>
                              </Col>
                            </AppRowContainer>
                          </div>
                        </Form>
                      </Modal>
                      <AppTableContainer
                        className={
                          'table-without-pagination quote-fields__list'
                        }
                        columns={columns}
                        rowKey={(record) => record.id}
                        dataSource={quoteFields}
                        pagination={false}
                        loading={loading}
                      />
                    </>
                  )}
                </Col>
              </>
            ) : (
              <AppLoader />
            )}
          </AppRowContainer>
        </AppsContainer>
      ) : (
        <NeedUserEmailVerification />
      )}
    </>
  );
};

export default QuotePage;
